var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientsMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-364788"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29721",
    "data-name": "Rectangle 29721",
    width: 19,
    height: 19,
    transform: "translate(-0.346 -0.346)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98446",
    "data-name": "Group 98446",
    transform: "translate(0.346 0.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97988",
    "data-name": "Group 97988",
    clipPath: "url(#clip-path-364788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86363",
    "data-name": "Path 86363",
    d: "M15.038,3.166h-.871A3.964,3.964,0,0,0,10.289,0H8.706A3.964,3.964,0,0,0,4.828,3.166H3.957A3.962,3.962,0,0,0,0,7.123v7.915A3.962,3.962,0,0,0,3.957,19H15.038A3.962,3.962,0,0,0,19,15.038V7.123a3.962,3.962,0,0,0-3.957-3.957M8.706,1.583h1.583a2.374,2.374,0,0,1,2.229,1.583H6.477A2.374,2.374,0,0,1,8.706,1.583M3.957,4.749H15.038a2.374,2.374,0,0,1,2.374,2.374V9.5H1.583V7.123A2.374,2.374,0,0,1,3.957,4.749M15.038,17.412H3.957a2.374,2.374,0,0,1-2.374-2.374V11.081H8.706v.791a.791.791,0,0,0,1.583,0v-.791h7.123v3.957a2.374,2.374,0,0,1-2.374,2.374",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsMenuIcon);
export default __webpack_public_path__ + "static/media/clients-menu-icon.af0c632fdc45caab372f71e475c584d6.svg";
export { ForwardRef as ReactComponent };